import { create } from 'zustand';

export type EntityType = 'email' | 'todo' | 'note';

export interface RecentlyAccessedItem {
  type: EntityType;
  id: string;
  title: string;
  accessedAt: Date;
}

export interface ComposePrefill {
  to: string;
  subject: string;
  body: string;
}

interface AppState {
  // Command palette
  isCommandPaletteOpen: boolean;
  setCommandPaletteOpen: (open: boolean) => void;

  // Compose modal pre-fill (from AI draft or SignalList action)
  composePrefill: ComposePrefill | null;
  setComposePrefill: (prefill: ComposePrefill | null) => void;

  // Recently accessed (for command palette empty state)
  recentlyAccessed: RecentlyAccessedItem[];
  addToRecentlyAccessed: (item: RecentlyAccessedItem) => void;

  // Active entity state (used by command palette navigation)
  activeEmailId: string | null;
  setActiveEmailId: (id: string | null) => void;
  activeTodoId: string | null;
  setActiveTodoId: (id: string | null) => void;
  activeNoteId: string | null;
  setActiveNoteId: (id: string | null) => void;
}

export const useAppStore = create<AppState>((set) => ({
  // Command palette
  isCommandPaletteOpen: false,
  setCommandPaletteOpen: (open) => set({ isCommandPaletteOpen: open }),

  // Compose modal pre-fill
  composePrefill: null,
  setComposePrefill: (prefill) => set({ composePrefill: prefill }),

  // Recently accessed - max 5 items, most recent first
  recentlyAccessed: [],
  addToRecentlyAccessed: (item) =>
    set((state) => {
      const filtered = state.recentlyAccessed.filter(
        (r) => !(r.type === item.type && r.id === item.id)
      );
      const updated = [item, ...filtered].slice(0, 5);
      return { recentlyAccessed: updated };
    }),

  // Active entity state
  activeEmailId: null,
  setActiveEmailId: (id) => set({ activeEmailId: id }),
  activeTodoId: null,
  setActiveTodoId: (id) => set({ activeTodoId: id }),
  activeNoteId: null,
  setActiveNoteId: (id) => set({ activeNoteId: id }),
}));
